import type { PartyLanguage } from '@doblaje/party';

/** The languages a party can be played in, each named in itself. */
export const LANGUAGES: [PartyLanguage, string][] = [
  ['en', 'English'],
  ['es', 'Español'],
  ['fr', 'Français'],
  ['pt', 'Português'],
  ['de', 'Deutsch'],
  ['it', 'Italiano'],
];
